import { lazy } from "react";
import { Navigate, RouteObject, useLocation } from "react-router-dom";

const PersonifyOutlet = lazy(() => import("../components"));
const Personify = lazy(() => import("../components/Personify"));
const MemberEnrollmentSurveyForm = lazy(
  () => import("../components/MemberEnrollment/MemberEnrollmentSurveyForm")
);
const PersonifyCustomiseLayout = lazy(
  () => import("../components/PersonifySetup/PersonifyCustomise/PersonifyCustomiseLayout")
);
const PersonifyCustomise = lazy(
  () => import("../components/PersonifySetup/PersonifyCustomise/PersonifyCustomise")
);
const PersonifySetupWizard = lazy(
  () => import("../components/PersonifySetup/PersonifySetupWizard")
);
const BuilderAccessGuard = lazy(
  () => import("../components/PersonifySetup/BuilderAccessGuard")
);
const PwaBuilderLanding = lazy(
  () => import("../components/PersonifySetup/PwaBuilderLanding")
);
const AppStyleStep = lazy(
  () => import("../components/PersonifySetup/steps/AppStyleStep")
);
const PagesStep = lazy(
  () => import("../components/PersonifySetup/steps/PagesStep")
);
const DesignStep = lazy(
  () => import("../components/PersonifySetup/steps/DesignStep")
);
const ContentStep = lazy(
  () => import("../components/PersonifySetup/steps/ContentStep")
);

const BUILDER_PATH = "/settings/modules/personify/builder";

const LegacyBuilderRedirect = () => {
  const { pathname, search } = useLocation();
  const target = pathname.replace("/settings/modules/personify/layout/", `${BUILDER_PATH}/layout/`);
  return <Navigate to={`${target}${search}`} replace />;
};

const PersonifyConfigRoute: RouteObject = {
  path: "/settings/modules/personify",
  element: <PersonifyOutlet />,
  children: [
    {
      path: "builder",
      element: <BuilderAccessGuard />,
      children: [
        { index: true, element: <PwaBuilderLanding /> },
        {
          path: "layout/customize",
          element: <PersonifySetupWizard />,
          children: [
            { index: true, element: <Navigate to="app-style" replace /> },
            { path: "app-style", element: <AppStyleStep /> },
            { path: "pages",     element: <PagesStep /> },
            { path: "design",    element: <DesignStep /> },
            { path: "content",   element: <ContentStep /> },
          ],
        },
        {
          path: "layout/custom-pwa/customize",
          element: <PersonifyCustomiseLayout />,
          children: [
            {
              path: "",
              element: <PersonifyCustomise />,
            },
          ],
        },
      ],
    },
    { path: "layout/*", element: <LegacyBuilderRedirect /> },
    {
      path: "",
      element: <Personify />,
    },
    {
      path: "enrollment-form",
      element: <MemberEnrollmentSurveyForm />,
    },
  ],
};

export default PersonifyConfigRoute;
